module.exports = __webpack_public_path__ + "img/schuettler.75c74414.png";